<script lang="ts">
import { IntentionI3pService } from '~/services/intentions.i3p.service'
import IntentionsI3p from '~/components/I3pComponent/intentions/IntentionsI3p.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'
import { useConfigStore } from '~/store'

export default {
    name: 'ToutesLesIntentions',
    components: {
        IntentionsI3p,
    },
    setup() {
        useHead({
            title: 'Toutes les intentions',
            meta: [
                { name: 'description', content: 'Toutes les intentions' },
            ],
        })
        definePageMeta({
            middleware: ['auth'],
        })
    },
    data() {
        const configStore = useConfigStore()
        const route = useRoute()
        return {
            configStore,
            route,
            baseUrl: BaseRoutesEnum.allIntentions,
            intentionI3pService: new IntentionI3pService()
                .setInitialQuery({ display_all_organizations: true, status: '_1_new,_2_active' })
                .setHiddenFilters(['my_organization_id', 'status', 'archive_status']),
        }
    },
    computed: {
        isApplicationServiceReady(): boolean {
            return !!this.configStore?.currentConfig?.app_info
        },
    },
    async mounted() {
        await this.intentionI3pService.loadData(!this.route.params.k)
    },
}
</script>

<template>
    <IntentionsI3p v-if="isApplicationServiceReady" :i3p-service="intentionI3pService" :base-url />
</template>
